module.exports = __webpack_public_path__ + "static/media/stella.44b33c34.jpeg";